import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
var write_t = Atdgen_codec_runtime.Encode.make(function (x) {
  var variant = x[0];

  if (variant !== 699531161) {
    if (variant >= 948354667) {
      return Atdgen_codec_runtime.Encode.constr1("User", Atdgen_codec_runtime.Encode.string, x[1]);
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Positional", Atdgen_codec_runtime.Encode.$$int, x[1]);
    }
  } else {
    return Atdgen_codec_runtime.Encode.constr1("Named", Atdgen_codec_runtime.Encode.string, x[1]);
  }
});
var read_t = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["User",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `User */
      [948354667, x]
    );
  }, Atdgen_codec_runtime.Decode.string, param);
}]],
/* :: */
[
/* tuple */
["Named",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Named */
      [699531161, x]
    );
  }, Atdgen_codec_runtime.Decode.string, param);
}]],
/* :: */
[
/* tuple */
["Positional",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Positional */
      [-300665356, x]
    );
  }, Atdgen_codec_runtime.Decode.$$int, param);
}]],
/* [] */
0]]]);
export { read_t, write_t };
/* write_t Not a pure module */